import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { TableHeader } from './table-header';

const TableTemplate = ({ children, headers }) => (
  <TableWrapper>
    <StyledTable>
      <thead>
        <TableHeader headers={headers} />
      </thead>
      <tbody>{children}</tbody>
    </StyledTable>
  </TableWrapper>
);

const TableWrapper = styled.div`
  overflow-x: auto;
`;

const StyledTable = styled.table`
  border-collapse: collapse;
  border: 1px solid ${({ theme }) => theme.colors.grey100};
  margin-bottom: 1rem;
  margin-top: 1rem;
  text-align: left;
  width: 100%;

  tr,
  td {
    border: 1px solid ${({ theme }) => theme.colors.grey100};
    border-collapse: collapse;
    padding: 0.5rem;
  }

  td {
    min-width: 200px;
  }

  tr {
    background-color: ${({ theme }) => theme.colors.white};
  }
`;

TableTemplate.propTypes = {
  children: PropTypes.node.isRequired,
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export { TableTemplate };
